<template>
  <div class="cmp-settings-identities dt-page">
    <v-layout v-if="!authenticated" class="needcred-form-container login-white" row wrap>
      <LoginForm :loginFormData="loginFormData" @change="onLoginUserChange" />
    </v-layout>
    <v-layout row wrap class="dt-page--top-bar" v-if="authenticated">
      <div class="dt-page--add-button">
        <img
          @click="onAddInvoiceProjectClick"
          class="dt-icon v5 s1"
          src="static/buttons/add.svg"
          :title="$t('add_invoice_project')"
          :alt="$t('add_invoice_project')"
        />
      </div>
    </v-layout>
    <v-layout column wrap v-if="authenticated">
      <div class="invoice-project-list-table-container">
        <NTable 
          class="h1" 
          :config="tableConfig" 
          :headers="headers" 
          :id="'settings-identities-identity_list'"
          :items="list"
          :loadingFlag="loadingFlag"  
        >
          <template v-slot:item="{ item ,tdcon }">
            <tr :title="item.fullname">
              <td @click="onInvoiceProjectClick(item)" v-bind="tdcon('invoice_projects')">
                <span>  {{item['invoice_project_name']}} </span>
              </td>
              <td v-bind="tdcon('currency')">
                <span>  {{item['currency_iso']}} </span>
              </td>
              <td v-bind="tdcon('country')">
                <span> {{item['country']}} </span>
              </td>
              <td v-bind="tdcon('invoice_ref')">
                <span> {{item['invoice_ref']}} </span>
              </td>
              <td v-bind="tdcon('options')" >
                <img
                  @click.stop="e => onInvoiceProjectDelete(item)"
                  src="static/icons/delete.svg"
                  class="dt-icon v5 s2"
                  :alt="$t('delete_invoice_project')"
                  :title="$t('delete_invoice_project')"
                />
              </td>
            </tr>
          </template>
        </NTable>
      </div>
    </v-layout>
    <Sidewindow :value="sidewindowFlag" @closed="closeSidewindow">
      <InvoiceProjectSidewindow />
    </Sidewindow>

    <ModalContainer v-if="authenticated" :modalKey="'createInvoiceProject'" :width="'small'" @cancelled="onHideComponentModal">
      <CreateInvoiceProject
        @added="onNewInvoiceProjectAdded"
        @cancelled="onHideComponentModal"
      />
    </ModalContainer>
  </div>
</template>

<script>

import { mapGetters } from "vuex";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import NTable from "@/plugins/datatable/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";
import Sidewindow from "@dtplugins/sidewindow/sidewindow";

import * as ActionTypes from "../../store/types";
import { SettingsStoreNamespace as storeNS } from "../../store";

import {
  createModalMixin,
  openModalRoute,
  closeModalRoute
} from "../../../../dt-plugins/modal/modal.mixin";

import { mapKeyToAction } from "../../../../store/global";

import InvoiceProjectSidewindow from "./invoice-project-sidewindow";

import {
  identitiesLDTRoutes,
  getInvoiceProjectDetailsSelectable,
  childOfOrEqualDetails,
} from "../../router/routes";

import LoginForm from "../../../../dt-plugins/login/login-form";
import { createNeedCredential } from "../../../../dt-plugins/credential/need-credential";
import CreateInvoiceProject from "./create-invoice-project";
import { createNTableConfig } from '../../../../plugins/datatable';
import { createTableHeader } from '../../../../plugins/datatable';
import { confirmDelete } from '../../../../dt-plugins/confirmation/confirmation-common';
export default {
  components: {
    NTable,
    InvoiceProjectSidewindow,
    LoginForm,
    Sidewindow,
    CreateInvoiceProject,
    ModalContainer,
  },
  mounted: async function() {},
  data: function() {
    return {
      tableConfig: createNTableConfig({
        fullHeight: true,
        rowHeight: 40
      }),

      loadingFlag: false,
    };
  },
  mixins: [
    createLDTHost({
      entityName: "invoiceProject",
      ldtRoutes: identitiesLDTRoutes,
      detailsSelectableFunction: getInvoiceProjectDetailsSelectable,
      primaryKey: "invoice_project_id",
      storeNs: storeNS,
      SELECT_ACTION: ActionTypes.InvoiceProjectDetails.FETCH.SINGLE,
      SELECT_AUTO_ACTION: ActionTypes.SELECT_INVOICE_PROJECT_AUTO
    }),
    createNeedCredential(),
    createModalMixin("createInvoiceProject"),
  ],
  watch: {},
  computed: {
    ...mapGetters(storeNS, {
      invoiceProjects: "invoiceProjects"
    }),
    // invoiceProjectHeaders: function() {
    //   return [
    //     { value: "invoice_projects", text: this.$t("invoice_projects") },
    //     { value: "currency", text: this.$t("currency") },
    //     { value: "country", text: this.$t("country") },
    //     { value: "invoice_ref", text: this.$t("invoice_ref") },
    //     { value: "options", text: '' },
    //   ];
    // },

    headers: function () {
      return [        
        createTableHeader("invoice_projects"),
        createTableHeader("currency"),
        createTableHeader("country"),
        createTableHeader("invoice_ref"),
        createTableHeader("options", {text: false}),

      ];
    },



    invoiceProjectDetailsFlag: function() {
      return childOfOrEqualDetails(this.$route);
    },
    list: function() {
      return this.invoiceProjects;
    },
  },
  methods: {
    ...mapKeyToAction(storeNS, [
      ActionTypes.Invoice_Projects.FETCH.ALL,
      ActionTypes.Invoice_Projects.SET.ALL,
      ActionTypes.Invoice_Projects.DELETE.SINGLE,
    ]),
    fetchList: async function() {
      this.loadingFlag = true;
      await this[ActionTypes.Invoice_Projects.FETCH.ALL]({
        user_name: this.username,
        password: this.password
      });
      this.loadingFlag = false;
    },
    // onInvoiceProjectSidewindowClose: function() {
    //   this.$router.push({
    //     name: identitiesLDTRoutes.names.list
    //   });
    // },
    onAddInvoiceProjectClick: function() {
      openModalRoute(this, "create_invoice_project");
    },
    onHideComponentModal: function() {
      closeModalRoute(this);
    },
    onInvoiceProjectClick: function(item) {
      const { invoice_project_id } = item;

      this.$router.push({
        name: identitiesLDTRoutes.names.tab,
        params: {
          invoice_project_id,
          tab: "overview"
        }
      });
    },
    onInvoiceProjectDelete: async function(invoiceProject) {
      // console.log(invoiceProject);
      const confirmationResult = await confirmDelete(
        "Invoice Project",
        invoiceProject.invoice_project_name
      );
      if (confirmationResult == "OK") {
        this[ActionTypes.Invoice_Projects.DELETE.SINGLE](invoiceProject);
      }
    },
    onNewInvoiceProjectAdded: function(invoiceProject) {
      const { invoice_projects, new_invoice_project_id } = invoiceProject;
      this[ActionTypes.Invoice_Projects.SET.ALL](invoice_projects);
      
      this.onInvoiceProjectClick({invoice_project_id: new_invoice_project_id});
    }
    //MARK: Method
  }
};
</script>

<style lang="scss">
.cmp-settings-identities {

  .invoice-project-list-table-container {
    // height: 100%;
    // background: green;
  }

  .dt-page--top-bar {
    .dt-tabs-container {
      margin-left: 20px;
    }
  }

  .dt-ntable {
    --ntable-height: calc(100vh - 130px);
    
    td:first-child {
      font-weight: 700;
      color: black;
      &:hover {
        text-decoration: underline;
      }
    }
    th:nth-child(5),
    td:nth-child(5) {
      flex: 0.12;
    }

    @media screen and (min-width: 320px) and (max-width: 480px) {
      th:nth-child(2),
      td:nth-child(2) {
        display: none;
      }
      th:nth-child(3),
      td:nth-child(3) {
        display: none;
      }
    }
  }
}
</style>
